// @flow

import {
  FETCH_USER_COURSES_FAILURE,
  FETCH_USER_COURSES_REQUEST,
  FETCH_USER_COURSES_SUCCESS,
  FETCH_PAST_USER_COURSES_FAILURE,
  FETCH_PAST_USER_COURSES_REQUEST,
  FETCH_PAST_USER_COURSES_SUCCESS,
  // FETCH_USER_COURSE_FAILURE,
  // FETCH_USER_COURSE_REQUEST,
  // FETCH_USER_COURSE_SUCCESS,
  // FETCH_USER_LEVEL_FAILURE,
  // FETCH_USER_LEVEL_REQUEST,
  // FETCH_USER_LEVEL_SUCCESS,
  CLEAR_USER_THINGS,
  UPDATE_COURSE_SECTION_END_DATE
} from '../actions/usercourses'

const initialState : {
  currentUserCourses: Array<Object>,
  // currentUserCourse: ?Object,
  // currentUserLevel: ?Object,
  pastUserCourses: Array<Object>,
  isFetchingUserCourses: boolean,
  isFetchingUserCourse: boolean,
  isFetchingUserLevel: boolean
} = {
  currentUserCourses: [],
  // currentUserCourse: null,
  // currentUserLevel: null,
  pastUserCourses: [],
  isFetchingUserCourses: false,
  isFetchingUserCourse: false,
  isFetchingUserLevel: false
}

export function usercourses (state: Object = initialState, action: Object) : Object {
  switch (action.type) {

    case FETCH_USER_COURSES_REQUEST:
      return Object.assign({}, state, {
        isFetchingUserCourses: true,
        currentUserCourses: [],
        currentUserCourse: null,
        currentUserLevel: null
      })

    case FETCH_USER_COURSES_FAILURE:
      return Object.assign({}, state, {
        isFetchingUserCourses: false,
        currentUserCourses: [],
        currentUserCourse: null,
        currentUserLevel: null
      })

    case FETCH_USER_COURSES_SUCCESS:
      return Object.assign({}, state, {
        isFetchingUserCourses: false,
        currentUserCourses: action.user_courses
      })

    case FETCH_PAST_USER_COURSES_REQUEST:
      return Object.assign({}, state, {
        isFetchingUserCourses: true,
        pastUserCourses: []
      })

    case FETCH_PAST_USER_COURSES_FAILURE:
      return Object.assign({}, state, {
        isFetchingUserCourses: false,
        pastUserCourses: []
      })

    case FETCH_PAST_USER_COURSES_SUCCESS:
      return Object.assign({}, state, {
        isFetchingUserCourses: false,
        pastUserCourses: action.past_user_courses
      })

    // case FETCH_USER_COURSE_REQUEST:
    //   return Object.assign({}, state, {
    //     isFetchingUserCourse: true,
    //     currentUserCourse: null,
    //     currentUserLevel: null
    //   })
    //
    // case FETCH_USER_COURSE_FAILURE:
    //   return Object.assign({}, state, {
    //     isFetchingUserCourse: false,
    //     currentUserCourse: null,
    //     currentUserLevel: null
    //   })
    //
    // case FETCH_USER_COURSE_SUCCESS:
    //   return Object.assign({}, state, {
    //     isFetchingUserCourse: false,
    //     currentUserCourse: action.user_course
    //   })
    //
    // case FETCH_USER_LEVEL_REQUEST:
    //   return Object.assign({}, state, {
    //     isFetchingUserLevel: true,
    //     currentUserLevel: null
    //   })
    //
    // case FETCH_USER_LEVEL_FAILURE:
    //   return Object.assign({}, state, {
    //     isFetchingUserLevel: false,
    //     currentUserLevel: null
    //   })
    //
    // case FETCH_USER_LEVEL_SUCCESS:
    //   return Object.assign({}, state, {
    //     isFetchingUserLevel: false,
    //     currentUserLevel: action.user_level
    //   })

    case CLEAR_USER_THINGS:
      return Object.assign({}, state, {
        currentUserCourse: null,
        currentUserLevel: null
      })

    case UPDATE_COURSE_SECTION_END_DATE:
      const currentCourses = [...state.currentUserCourses]
      const pastCourses = [...state.pastUserCourses]

      const index = currentCourses.findIndex(c => c.course_section.id === action.courseSectionId)
      const course = currentCourses[index]

      course.course_section.end_at = action.endDate
      course.course_section.active = false

      currentCourses.splice(index, 1)
      pastCourses.push(course)

      return Object.assign({}, state, {
        currentUserCourses: currentCourses,
        pastUserCourses: pastCourses
      })

    default:
      return state
  }
}
